import React from "react";
import { Tooltip } from "antd";
import {
  UnderlyingContent,
  TableLabel,
  Title,
  CustomizedIcon,
} from "../../Epics/Grants/Pages/RecommendGrant/style";
import { addressFormat } from "../../Epics/Grants/Pages/RecommendGrant/utils";
import {removeNtee} from './utils'
import { CapsuleButton } from "../Commons/commonComponents";

export const tableConfig = (
  pendingCharityHandler,
  savedCharityModal,
  removeSavedCharityModal,
  activityBlocked = "",
  searchResultClickHandler
) => {
  return [
    {
      title: () => <div />,
      dataIndex: "isSelected",
      key: "isSelected",
      render: (value, record) => {
        if (record.loading) {
          return <CustomizedIcon type="loading" />;
        }
        return (
          <div>
            {value ? (
              <Tooltip placement="right" title="Remove Charity">
                <CustomizedIcon
                  type="star"
                  theme="filled"
                  data-test="ico-remove-charity"
                  onClick={() => savedCharityModal(record)}
                />
              </Tooltip>
            ) : (
              <Tooltip placement="right" title="Save Charity">
                <CustomizedIcon
                  type="star"
                  theme="outlined"
                  data-test="ico-save-charity"
                  onClick={() => removeSavedCharityModal(record)}
                />
              </Tooltip>
            )}
          </div>
        );
      },
      width: 10
    },
    {
      title: () => <Title>Legal Name</Title>,
      dataIndex: "organization_name",
      key: "organization_name",
      render: (value, record) => {
        return (
          <UnderlyingContent
           data-test="underlying-content"
            onClick={() => searchResultClickHandler(record.ein)}
            target="_blank"
          >
            {value}{" "}
          </UnderlyingContent>
        );
      },
      width: 180
    },
    {
      title: () => <Title>EIN</Title>,
      dataIndex: "ein",
      key: "ein",
      render: value => {
        return <TableLabel>{value}</TableLabel>;
      },
      width: 124
    },
    {
      title: () => <Title>Address</Title>,
      dataIndex: "city",
      key: "city",
      render: (value, record) => {
        return (
          <Tooltip
            placement="bottom"
            title={addressFormat({
              addressLine1: record.address_line_1,
              addressLine2: record.address_line_2,
              city: record.city,
              state: record.state,
              zipCode: record.zip
            })}
          >
            <UnderlyingContent>{value + "," + record.state}</UnderlyingContent>
          </Tooltip>
        );
      },
      width: 147
    },
    {
      title: () => <Title>Interest Area</Title>,
      dataIndex: "ntee_code",
      key: "ntee_code",
      render: value => {
        return <TableLabel>{removeNtee(value)} </TableLabel>;      },
      width: 130
    },
    {
      title: () => <div />,
      dataIndex: "isPending",
      key: "isPending",
      render: (value, record) => {
        return (
          <div>
            <CapsuleButton 
              data-test="capsuleButton"
              text = "Select"
              onClick={() => pendingCharityHandler(record)}
              disabled={!!activityBlocked || record.loading}
              title={activityBlocked}
              whiteBackground = {true}
              iconType = "arrowRight"
              alt = "Right arrow"
            />
          </div>
        );
      },
      width: 10
    }
  ];
};
